import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"

import { ref, onMounted, onUnmounted } from "vue";
import { hasConsent } from "~/js/utils/cookie-script";

interface Props {
	utilities?: string;
	skipCheck?: boolean;
	categories: Array<string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsentForm',
  props: {
    utilities: { default: "" },
    skipCheck: { type: Boolean },
    categories: {}
  },
  setup(__props: any) {

const props = __props;

const consentGiven = ref(false);

const updateConsent = () => {
	consentGiven.value = hasConsent(props.categories, Boolean(props.skipCheck));
};

onMounted(() => {
	updateConsent();
	window.addEventListener("ConsentUpdated", updateConsent);
});

onUnmounted(() => {
	window.removeEventListener("ConsentUpdated", updateConsent);
});

return (_ctx: any,_cache: any) => {
  return (!consentGiven.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
				'h-full w-full',
				'flex items-center justify-center',
				'p-8',
				'bg-white',
				'relative overflow-hidden',
				'aspect-video',
				__props.utilities,
			])
      }, [...(_cache[0] || (_cache[0] = [
        _createStaticVNode("<div class=\"absolute left-0 top-0 w-full animate-pulse-slow space-y-4 py-4 opacity-30\"><div class=\"w-full rounded-full bg-concrete-200 py-4\"></div><div class=\"flex space-x-4\"><div class=\"w-full rounded-full bg-concrete-200 py-4\"></div><div class=\"w-full rounded-full bg-concrete-200 py-4\"></div></div><div class=\"w-full rounded-full bg-concrete-200 py-4\"></div><div class=\"w-full rounded-full bg-concrete-200 py-4\"></div><div class=\"flex space-x-4\"><div class=\"w-full rounded-full bg-concrete-200 py-4\"></div><div class=\"w-full rounded-full bg-concrete-200 py-4\"></div></div><div class=\"flex justify-end\"><div class=\"w-40 rounded-full bg-viridian-500 py-4 opacity-40\"></div></div></div>", 1)
      ]))], 2))
    : _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 1)
}
}

})